module.exports = __webpack_public_path__ + "static/media/fam.b7e6fd5e.webp";